import React from 'react'
import Bredcom from '../Bredcom/Main' 
import Header from '../headerone/Main' 


 
function WomenCell() { 
  return ( 
    <> 
        <Header/> 
        <Bredcom title="Home" subtitle="Women Cell" />
        <section className="project-detail">
                <div className="container">
                    <div className="lower-content">
                        <div className="row">
                            <div className="text-column col-lg-12 col-md-12 col-sm-12">                               
                                <div className="inner-column">
                                    <h2>Women Cell</h2>
                                    <table className="table table-bordered mb-40">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Name</th>
                                                <th>Designation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>Dr. Rubby Mittal</td>
                                                <td>Chairmain</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Dr. Ramveer Singh</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>Ms. Babita Yadav</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>Ms. Madhu Bala</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>5</td>
                                                <td>Ms. Neha Kumari</td>
                                                <td>Member</td>
                                            </tr>
                                            
                                            <tr>
                                                <td>6</td>
                                                <td>Ms. Ruchi, LLB (22SL4019)</td>
                                                <td>Student Representative</td>
                                            </tr>
                                            <tr>
                                                <td>7</td>
                                                <td>Ms. Vanshikha, B.Pharm (22PS1056)</td>
                                                <td>Student Representative</td>
                                            </tr>
                                            <tr>
                                                <td>8</td>
                                                <td>Dy. Registrar</td>
                                                <td>Member Secretary</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> 
        
    </> 
  ) 
} 
 
export default WomenCell 